import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../../api-service/api.service';
import { MenuItem } from './menu-item';

@Injectable()
export class MenuService {
  constructor(private api: ApiService) {}

  getMenuItems(url: string): Observable<MenuItem> {
    return this.api.get(url);
  }
}
